import { useEffect } from 'react';
import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useLocation } from 'react-router-dom';

// Configure nProgress
nProgress.configure({ showSpinner: false, speed: 500, minimum: 0.1 });

const GlobalLoader = () => {
    const location = useLocation();

    useEffect(() => {
        nProgress.start();
        const timer = setTimeout(() => {
            nProgress.done();
        }, 200);

        return () => {
            clearTimeout(timer);
            nProgress.done();
        };
    }, [location.pathname]);

    return null;
};

export default GlobalLoader;
